import { createNavigation } from "next-intl/navigation";

import { routing } from "./routing";

/** Link/redirect/usePathname/useRouter, которые сами держат префикс языка (KAN-1188). */
export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);
